import React from 'react'
import axios from 'axios'
import {
	Button,
	Input
} from 'reactstrap'

import IngredientsActions from '~/actions/ingredients.js'

import apiUtils from '~/helper/api.js'


export default class RecipeIngredientsModalAddEdit extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			btnSubmitDisabled: true,
			ingredient: props.ingredient
		}
	}

	componentDidMount() {
		this.setSubmitButtonStatus()
	}

	setSubmitButtonStatus = () => {
		this.setState({
			btnSubmitDisabled: (
				this.state.ingredient === ''
			)
		})
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	submit = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.put(
			`${apiUtils.getApiURL()}/ingredients`,
			{
				ingredientID: this.props.ingredientID,
				ingredient: this.state.ingredient,
				isActive: 1
			}
		)
			.then(
				() => {
					this.props.cancelFunction()

					// refresh the list
					IngredientsActions.reload()
				}
			)
	}

	render() {
		const objSubmitButton = {}

		if (this.state.btnSubmitDisabled === true) {
			objSubmitButton.title = 'Enter ingredient to enable this button'
		}


		return (
			<tr>
				<td>
					<Input
						name="ingredient"
						value={this.state.ingredient}
						onChange={this.handleChange}
						maxLength={32}
					/>
				</td>
				<td>
					<Button
						onClick={this.submit}
						color="primary"
						disabled={this.state.btnSubmitDisabled}
						block
						{...objSubmitButton}
					>
						Save
					</Button>
				</td>
				<td>
					<Button
						onClick={this.props.cancelFunction}
						color="secondary"
						block
					>
						Cancel
					</Button>
				</td>
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredients/edit.jsx